import { GatsbyImage } from 'gatsby-plugin-image';
import { useContext } from 'react';

import { SocialMedia as TSocialMedia } from 'typescriptDefs/layout';

import { LocaleContext } from '../Layout';
import { Link } from '../Link';
import { P } from '../Typography';

export const SocialMedia = ({ socialMedia, title }: { socialMedia: TSocialMedia[]; title: string }) => {
  const locale = useContext(LocaleContext);

  return (
    <div className="mb-64 flex flex-col lg:mb-48 lg:items-center">
      <P className="mb-16 text-md md:text-md lg:mb-24 lg:text-center">{title}</P>
      <div className="flex flex-wrap items-center gap-16 lg:gap-32">
        {socialMedia.map((platform) => (
          <Link
            target="_blank"
            rel="noopener noreferrer"
            key={platform.image.altText}
            href={locale === 'fr' && platform.urlFr ? platform.urlFr : platform.url}
          >
            <GatsbyImage
              className="h-24 w-24"
              image={platform.image.img.asset.gatsbyImageData}
              alt={platform.image.altText}
            />
          </Link>
        ))}
      </div>
    </div>
  );
};
